/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/save_medium'
export default icon
